import { Component } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import api from "../../services/api";

/**
 * Centros de referência do médico do atendimento.
 *
 * O atendimento não tem centro próprio: ele vem do cadastro do médico. Some quando o médico
 * não tem centro ou quando o perfil não pode ler os centros (a API responde 403).
 */
class CentrosDoMedico extends Component {
    constructor(props) {
        super(props);
        this.state = { centros: [] };
    }

    componentDidMount() {
        this.carregar();
    }

    componentDidUpdate(anterior) {
        if (anterior.medicoId !== this.props.medicoId) {
            this.carregar();
        }
    }

    carregar = async () => {
        const { medicoId } = this.props;
        if (!medicoId) {
            this.setState({ centros: [] });
            return;
        }

        try {
            const { data } = await api.get(`/centros_referencia/prestadores/`, { params: { prestador_id: medicoId } });
            this.setState({ centros: (data.results || []).filter((c) => c.dados_centro) });
        } catch (error) {
            // bloco informativo: sem permissão ou falha, não aparece
            this.setState({ centros: [] });
        }
    };

    render() {
        const { t } = this.props;
        const { centros } = this.state;
        if (!centros.length) return null;

        const descricao = centros.map(({ dados_centro: c }) => {
            const local = [c.cidade, c.uf].filter(Boolean).join("/");
            return local ? `${c.nome} (${local})` : c.nome;
        }).join("; ");

        return (
            <p className="mb-1">
                <small>{t("atendimentosEdit:dados.referenceCenter")} </small> <strong>{descricao}</strong>
            </p>
        );
    }
}

CentrosDoMedico.propTypes = {
    medicoId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    t: PropTypes.func.isRequired,
};

export default withTranslation(["atendimentosEdit"])(CentrosDoMedico);
